const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORDNO",
                "tableName": "",
                "label": "Record #",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly":true,
            } ,
            {
                "name": "PROFILECODE",
                "tableName": "",
                "label": "Profile",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": true,
                "visible": true
            } ,
            {
                "name": "DESCRIPTION",
                "tableName": "",
                "label": "Description",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            }  ,
            {
                "name": "POPUPMESSAGE",
                "tableName": "",
                "label": "Popup Msg",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
                
            } ,
            {
                "name": "COMMENT",
                "tableName": "",
                "label": "Comment",
                "type": "textarea",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 2,
        "label": "User Defined Codes",
        "fields": [
            {
                "name": "USERDEFINEDCODE_1",
                "tableName": "",
                "label": "Code 1",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },{
                "name": "USERDEFINEDCODE_2",
                "tableName": "",
                "label": "Code 2",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
 
            },{
                "name": "USERDEFINEDCODE_3",
                "tableName": "",
                "label": "Code 3",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },{
                "name": "USERDEFINEDCODE_4",
                "tableName": "",
                "label": "Code 4",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },{
                "name": "USERDEFINEDCODE_5",
                "tableName": "",
                "label": "Code 5",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            }  
        ]
    } 
];

export {
    PrimaryLayout,
    }
